import { createBemClass, DEFAULT_OPTIONS, mapFacets } from 'util/misc/facets';

const PROPS_CONFIG = {
    facets: {
        type: Array,
        default() {
            return [];
        },
    },
};

/**
 * Generate the bem mixin
 * @param {string} bemRoot - module root class name
 * @param {IFacetOptions} config - facet config
 * @return {*} - mixin
 */
export default function bemMixin(bemRoot, config) {
    const options = {
        ...DEFAULT_OPTIONS,
        useProp: true,
        ...config,
    };

    return {
        props: options.useProp ? PROPS_CONFIG : {},
        computed: {
            bemRoot() {
                return bemRoot;
            },

            /**
             * Generate facets
             * @return {string[]} - array of facets
             */
            bemFacets() {
                return mapFacets(this.bemRoot, this.facets, options);
            },
        },
        methods: {
            /**
             * Generate class name
             * @param {string} modifierName - modifier name
             * @param {string} elementName - name of child
             * @param {string} rootName - name of root element
             * @return {string} - created classname
             */
            bemAdd(modifierName, elementName, rootName) {
                const blockName = rootName || this.bemRoot;
                return createBemClass({ blockName, modifierName, elementName, ...options });
            },

            /**
             * Add conditioned modifier
             * @param {boolean} condition - condition
             * @param {string} trueModifier - modifier if condition is true
             * @param {string} falseModifier - modifier if condition is false
             * @return {string} - generated class name
             */
            bemIf(condition, trueModifier, falseModifier) {
                return this.bemAdd(condition ? trueModifier : falseModifier);
            },
        },
    };
};
